<script>
import { Bar } from 'vue-chartjs';
import { renderChartHtmlTooltip } from '../../utils';

export default {
  extends: Bar,
  props: {
    chartLabel: Array,
    chartData: Array,
    chartOptions: {
      type: Object,
      default: function () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {
              enabled: false,
              custom: function (tooltipModel) {
                renderChartHtmlTooltip(tooltipModel, this);
              }
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart({
      labels: this.chartLabel,
      datasets: this.chartData
    }, this.chartOptions)
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/charts/BarChart.vue